/**
 * en-GB messages added by Phase 4 task C7 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const c7EnGB = {
    'auth.error.sso_unavailable': 'Microsoft sign-in is not available for this address.',
    'auth.error.sso_not_connected': 'Connect your Microsoft 365 directory before turning Microsoft sign-in on.',
    'auth.error.sso_domain_invalid': 'Enter email domains such as example.co.uk, without an @ sign.',
    'auth.error.sso_required': 'Your organisation requires Microsoft sign-in. Use "Sign in with Microsoft" instead.',
    'auth.sso.button': 'Sign in with Microsoft',
    'auth.sso.error.failed': 'Microsoft sign-in did not work. Please try again.',
    'auth.sso.error.cancelled': 'Microsoft sign-in was cancelled.',
    'auth.sso.error.expired': 'That Microsoft sign-in has expired or was already used. Please start again.',
    'auth.sso.error.email_missing': 'Microsoft did not send your email address. Ask your Microsoft 365 administrator to turn on the optional "email" claim for CloudSign (Entra, App registrations, Token configuration), then try again.',
    'auth.sso.error.not_allowed': 'This Microsoft account cannot sign in here. Ask your administrator to check that you have a CloudSign user with the same email address.',
    'auth.sso.error.unavailable': 'Microsoft sign-in is not turned on for this organisation.',
    // FX2 (ADR 0028 amendment): domain proof.
    'auth.error.sso_domain_check_failed': 'We could not look up that domain just now. Please try again in a few minutes.',
    'auth.error.sso_domain_txt_missing': 'We could not find the TXT record yet. DNS changes can take up to an hour to show; check the record and try again.',
    'auth.error.sso_domain_taken': 'Another organisation has already proven this domain. Contact support if it belongs to you.',
    'sso.domains.proofHint': 'Microsoft sign-in is offered for an email domain only after you prove you own it. Add this TXT record at your DNS provider, then choose Check now.',
    'sso.domains.verifiedStatus': 'Proven',
    'sso.domains.pendingStatus': 'Not proven yet',
    'sso.domains.recordName': 'TXT record name',
    'sso.domains.recordValue': 'TXT record value',
    'sso.domains.check': 'Check now',
    'sso.domains.checked': '{domain} is proven.',
    'sso.connect.signInHint': 'After approving, Microsoft asks you to sign in with an account in that organisation. This confirms which Microsoft 365 directory is connected.',
    'sso.mode.off': 'Off',
    'sso.mode.optional': 'Optional',
    'sso.mode.required': 'Required',
};
//# sourceMappingURL=c7.js.map